import { NodeModel } from '@minoru/react-dnd-treeview';
import {
    WorkshiftSchedulingModel,
    WorkshiftsListModel,
} from '../../models/workshifts/workshif-scheduling/workshiftSchedulingList.model';
import { getChildNodes, getDatesBetweenDates } from '../../utils';
import { EmployeeNodeModel } from '../../models';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    workshiftShedulingList: WorkshiftsListModel;
    handlerDeleteOperationsCenterModal: (
        startDate: string,
        endDate: string,
        employee: EmployeeNodeModel[],
        ids: number[]
    ) => void;
    getWorkshiftScheduling: (
        date: string | number,
        employeeID: string | number,
        workshiftShedulingList: WorkshiftsListModel
    ) => WorkshiftSchedulingModel | undefined;
};

export const controllerDeleteOperationCenterModal = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    workshiftShedulingList,
    handlerDeleteOperationsCenterModal,
    getWorkshiftScheduling,
}: Props) => {
    let recoveredData = window.localStorage.getItem('selection-range');

    if (recoveredData) {
        let data: Array<{
            employeeId: string | number;
            text: string;
            date: string;
        }> = JSON.parse(recoveredData);
        if (data.length > 0) {
            let idsList: number[] = [];

            data.forEach((emp) => {
                let workshiftId = getWorkshiftScheduling(
                    emp.date,
                    emp.employeeId,
                    workshiftShedulingList
                )?.id;

                if (workshiftId) {
                    idsList.push(workshiftId);
                }
            });

            let employees: NodeModel[] = data.map((emp) => ({
                id: emp.employeeId,
                parent: '',
                text: emp.text,
                droppable: false,
            }));

            handlerDeleteOperationsCenterModal('', '', employees, idsList);
        }
    } else {
        let row1 = grid.selectedRanges[0].row;
        let row2 = grid.selectedRanges[0].row2;
        let col1 = grid.selectedRanges[0].col - 2;
        let col2 = grid.selectedRanges[0].col2 - 2;

        if (row1 > row2) {
            let aux = row1;
            row1 = row2;
            row2 = aux;
        }

        if (col1 > col2) {
            let aux = col1;
            col1 = col2;
            col2 = aux;
        }

        let initDate = getDatesBetweenDates(startDate, endDate)[col1];
        let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

        let selectedEmployees = getChildNodes(treeEmployees).slice(row1, row2 + 1);

        let dates = getDatesBetweenDates(initDate, lastDate);

        let opIds: number[] = [];

        workshiftShedulingList.schedulings.map((w) => {
            if (
                dates.includes(
                    w.workshiftSchedulingOperationCenter?.startDate.split('T')[0] ??
                        ''
                ) &&
                selectedEmployees.map((e) => e.id).includes(w.employeeId)
            ) {
                if (w.workshiftSchedulingOperationCenter)
                    opIds.push(w.workshiftSchedulingOperationCenter?.id);
            }
        });

        if (
            initDate &&
            lastDate &&
            selectedEmployees.length > 0 &&
            opIds.length > 0
        ) {
            handlerDeleteOperationsCenterModal(
                initDate,
                lastDate,
                selectedEmployees,
                opIds
            );
        }
    }
};
